import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../common.service';

function getPasswordRuleStatus(password: string) {
  const pwd = password || '';
  const hasUpper = /[A-Z]/.test(pwd);
  const hasLower = /[a-z]/.test(pwd);
  const hasDigit = /\d/.test(pwd);
  const hasSpecial = /[^A-Za-z0-9]/.test(pwd);
  const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length;
  return {
    minLength: pwd.length >= 8,
    complexity: typeCount >= 3
  };
}

@Component({
  selector: 'force-change-password',
  templateUrl: './force-change-password.component.html',
  styleUrls: ['./force-change-password.component.css']
})
export class ForceChangePasswordComponent implements OnInit {
  /** 登录时输入的密码，预填当前密码 */
  @Input() defaultOldPassword = '';
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<{
    currentPassword: string;
    newPassword: string;
    /** 仅供本地更新表单，不用于接口传输 */
    plainNewPassword: string;
  }>();

  assetsRoute = '../../assets/';
  submitting = false;
  oldPwdVisible = false;
  newPwdVisible = false;
  confirmPwdVisible = false;

  form = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };

  errors = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };

  constructor(private commonService: CommonService) {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
  }

  ngOnInit() {
    if (this.defaultOldPassword) {
      this.form.oldPassword = this.defaultOldPassword;
    }
  }

  /** 三项齐全且新密码符合规则时才可提交 */
  get canSubmit(): boolean {
    if (this.submitting) {
      return false;
    }
    const { oldPassword, newPassword, confirmPassword } = this.form;
    if (!oldPassword || !newPassword || !confirmPassword) {
      return false;
    }
    const status = getPasswordRuleStatus(newPassword);
    if (!status.minLength || !status.complexity) {
      return false;
    }
    if (newPassword === oldPassword) {
      return false;
    }
    if (confirmPassword !== newPassword) {
      return false;
    }
    return true;
  }

  hide() {
    this.close.emit();
  }

  handleFormBlur() {
    window.scroll(0, 0);
  }

  onNewPasswordInput() {
    this.validateNewPassword();
    if (this.form.confirmPassword) {
      this.validateConfirmPassword();
    }
  }

  onConfirmPasswordInput() {
    this.validateConfirmPassword();
  }

  validateOldPassword(): boolean {
    if (!this.form.oldPassword) {
      this.errors.oldPassword = '请输入当前密码';
      return false;
    }
    this.errors.oldPassword = '';
    return true;
  }

  validateNewPassword(): boolean {
    if (!this.form.newPassword) {
      this.errors.newPassword = '请输入新密码';
      return false;
    }
    const status = getPasswordRuleStatus(this.form.newPassword);
    if (!status.minLength && !status.complexity) {
      this.errors.newPassword = '密码不符合安全要求，请输入8位以上且包含至少三种字符类型的密码';
      return false;
    }
    if (!status.minLength) {
      this.errors.newPassword = '密码长度不足，请输入8位以上密码';
      return false;
    }
    if (!status.complexity) {
      this.errors.newPassword = '密码复杂度不足，请至少包含大写字母、小写字母、数字、特殊字符中的三类';
      return false;
    }
    if (this.form.newPassword === this.form.oldPassword) {
      this.errors.newPassword = '新密码不能与当前密码相同';
      return false;
    }
    this.errors.newPassword = '';
    return true;
  }

  validateConfirmPassword(): boolean {
    if (!this.form.confirmPassword) {
      this.errors.confirmPassword = '请再次输入新密码';
      return false;
    }
    if (this.form.confirmPassword !== this.form.newPassword) {
      this.errors.confirmPassword = '两次输入的新密码不一致';
      return false;
    }
    this.errors.confirmPassword = '';
    return true;
  }

  submit() {
    if (!this.canSubmit || this.submitting) {
      return;
    }
    const oldValid = this.validateOldPassword();
    const newValid = this.validateNewPassword();
    const confirmValid = this.validateConfirmPassword();
    if (!oldValid || !newValid || !confirmValid) {
      return;
    }
    this.submitting = true;
    // 与登录一致：出站密码使用 encrypt，禁止明文传递
    this.success.emit({
      currentPassword: this.commonService.encrypt(this.form.oldPassword),
      newPassword: this.commonService.encrypt(this.form.newPassword),
      // 仅供本地更新表单，不用于接口传输
      plainNewPassword: this.form.newPassword
    });
  }

  /** 父组件改密失败时恢复可提交状态 */
  resetSubmitting() {
    this.submitting = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/force-change-password/force-change-password.component.ts